import { animate, state, style, transition, trigger } from '@angular/animations';
import { IsDeviceWeak } from './is-device-weak.utils';

export const fadeIn = trigger(
  'fadeIn',
  IsDeviceWeak() ? [] : [transition(':enter', [style({ opacity: 0 }), animate('500ms ease-out', style({ opacity: 1 }))])]
);

export const fadeInUp = trigger('fadeInUp', [
  transition(
    ':enter',
    IsDeviceWeak()
      ? []
      : [style({ opacity: 0, transform: 'translateY(20px)' }), animate('500ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))]
  )
]);

export const fadeInOut = [
  trigger(
    'fadeInOut',
    IsDeviceWeak()
      ? []
      : [
          state(
            'fadeIn',
            style({
              opacity: 1
            })
          ),
          state(
            'fadeOut',
            style({
              opacity: 0
            })
          ),
          transition('fadeIn => fadeOut', [animate('0.5s')]),
          transition('fadeOut => fadeIn', [animate('0.5s')])
        ]
  )
];
